// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3WdMa","header":"ReportDetails_header__8Sbv4","title":"ReportDetails_title__N1_2X","left":"ReportDetails_left__m-Yny"};